import { bunja } from 'bunja';

import { spotsAtom } from './internal/fixed-topics/spots';
import { r230522SocketBunja } from './socket';

export type * from './internal/fixed-topics/spots';

export const spotsBunja = bunja(() => {
  bunja.use(r230522SocketBunja);
  return { spotsAtom };
});
spotsBunja.debugLabel = 'spotsBunja';
